export default function Mutualfunds(){

    return (
        <div  >
        <p>Mutual funds page</p>
      </div>
    )
}